(function () {
  'use strict';

  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  headers.forEach(initHeader);

  function initHeader(header) {
    var megaMenu = header.querySelector('[data-mega-menu-panel]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var mobileMenu = header.querySelector('[data-mobile-menu-panel]');
    var mobileMenuToggles = header.querySelectorAll('[data-mobile-menu-toggle]');
    var mobileMenuCloses = header.querySelectorAll('[data-mobile-menu-close]');
    var mobileAccordionTriggers = mobileMenu
      ? mobileMenu.querySelectorAll('[data-mobile-accordion-trigger]')
      : [];
    var mobileSubTriggers = mobileMenu
      ? mobileMenu.querySelectorAll('[data-mobile-subaccordion-trigger]')
      : [];
    var mobileMenuOpener = null;
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    var searchToggles = header.querySelectorAll('[data-search-toggle]');
    var desktopSearchInput = header.querySelector('.oddit-header__search-input');

    var activeTrigger = null;
    var megaCloseTimer = null;

    function openMegaMenu(label) {
      if (!megaMenu) return;
      var allPanels = megaMenu.querySelectorAll('[data-mega-menu-label]');
      var found = false;
      allPanels.forEach(function (panel) {
        if (panel.getAttribute('data-mega-menu-label') === label) {
          panel.style.display = '';
          panel.classList.add('is-active');
          found = true;
        } else {
          panel.style.display = 'none';
          panel.classList.remove('is-active');
        }
      });
      if (found) {
        megaMenu.classList.add('is-open');
        megaMenu.setAttribute('aria-hidden', 'false');
      } else {
        closeMegaMenu();
      }
    }

    function closeMegaMenu() {
      clearTimeout(megaCloseTimer);
      if (megaMenu) {
        megaMenu.classList.remove('is-open');
        megaMenu.setAttribute('aria-hidden', 'true');
      }
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
    }

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        closeMegaMenu();
      }, 180);
    }

    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    // Wire mega menu triggers
    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isCurrentlyOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        if (wrapper) {
          wrapper.addEventListener('pointerenter', function (e) {
            if (!isHoverPointer(e)) return;
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('pointerleave', function (e) {
            if (!isHoverPointer(e)) return;
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    if (megaMenu) {
      megaMenu.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    // Close mega menu on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (megaMenu && megaMenu.classList.contains('is-open')) {
          closeMegaMenu();
          if (activeTrigger) activeTrigger.focus();
        }
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          closeMobileMenu();
        }
      }
    });

    // ----------------------------------------------------------------------
    // Mobile menu open / close
    // ----------------------------------------------------------------------
    // Visible, focusable elements within a container (skips collapsed
    // accordion panels, which carry the `hidden` attribute).
    function getFocusable(container) {
      var nodes = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var out = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getClientRects().length) out.push(nodes[i]);
      }
      return out;
    }

    function openMobileMenu() {
      if (!mobileMenu) return;
      mobileMenuOpener = document.activeElement;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      for (var i = 0; i < mobileMenuToggles.length; i++) {
        mobileMenuToggles[i].setAttribute('aria-expanded', 'true');
      }
      var firstInteractive = mobileMenu.querySelector('input, button, a');
      if (firstInteractive) firstInteractive.focus({ preventScroll: true });
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      for (var i = 0; i < mobileMenuToggles.length; i++) {
        mobileMenuToggles[i].setAttribute('aria-expanded', 'false');
      }
      if (mobileMenuOpener && typeof mobileMenuOpener.focus === 'function') {
        mobileMenuOpener.focus({ preventScroll: true });
      }
      mobileMenuOpener = null;
    }

    for (var m = 0; m < mobileMenuToggles.length; m++) {
      mobileMenuToggles[m].addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    for (var c = 0; c < mobileMenuCloses.length; c++) {
      mobileMenuCloses[c].addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileMenu();
      });
    }

    // Trap Tab focus within the open mobile menu.
    if (mobileMenu) {
      mobileMenu.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !mobileMenu.classList.contains('is-open')) return;
        var focusable = getFocusable(mobileMenu);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    // ----------------------------------------------------------------------
    // Mobile menu accordions (mega-menu collections & sub-navigation)
    // ----------------------------------------------------------------------
    function setMobileAccordion(trigger, open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (panel) {
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
      var item = trigger.closest('.oddit-header__mobile-nav-item');
      if (item) item.classList.toggle('is-expanded', open);
    }

    for (var a = 0; a < mobileAccordionTriggers.length; a++) {
      mobileAccordionTriggers[a].addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        // Single panel open at a time.
        for (var i = 0; i < mobileAccordionTriggers.length; i++) {
          if (mobileAccordionTriggers[i] !== this) {
            setMobileAccordion(mobileAccordionTriggers[i], false);
          }
        }
        setMobileAccordion(this, !isOpen);
      });
    }

    // Nested per-column accordions inside a mega-menu panel. These toggle
    // independently (multiple columns may be open at once).
    function setMobileSubAccordion(trigger, open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (panel) {
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
      var col = trigger.closest('.oddit-header__mobile-nav-col');
      if (col) col.classList.toggle('is-expanded', open);
    }

    for (var sa = 0; sa < mobileSubTriggers.length; sa++) {
      mobileSubTriggers[sa].addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        // Single column open at a time, scoped to the parent mega-menu panel.
        var parentPanel = this.closest('[data-mobile-accordion-panel]');
        var siblings = parentPanel
          ? parentPanel.querySelectorAll('[data-mobile-subaccordion-trigger]')
          : mobileSubTriggers;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== this) setMobileSubAccordion(siblings[i], false);
        }
        setMobileSubAccordion(this, !isOpen);
      });
    }

    // ----------------------------------------------------------------------
    // Cart drawer triggers — open via global API
    // ----------------------------------------------------------------------
    for (var ct = 0; ct < cartToggles.length; ct++) {
      cartToggles[ct].addEventListener('click', function (e) {
        e.preventDefault();
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      });
    }

    // ----------------------------------------------------------------------
    // Search drawer triggers — open via global API, else go to the search page
    // ----------------------------------------------------------------------
    function openSearch(trigger) {
      if (window.OdditSearchDrawer && typeof window.OdditSearchDrawer.open === 'function') {
        window.OdditSearchDrawer.open();
        return true;
      }
      var url = trigger && trigger.getAttribute('data-search-url');
      if (url) {
        window.location.assign(url);
        return true;
      }
      return false;
    }

    for (var st = 0; st < searchToggles.length; st++) {
      searchToggles[st].addEventListener('click', function (e) {
        e.preventDefault();
        openSearch(this);
      });
    }

    // If a desktop search input is present in the header, defer to the search
    // drawer on focus instead of acting as a standalone search field.
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('focus', function () {
        if (window.OdditSearchDrawer && typeof window.OdditSearchDrawer.open === 'function') {
          window.OdditSearchDrawer.open();
          this.blur();
        }
      });
    }
  }

  // Live cart count badge updates (shared, global)
  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();